import React from "react";

const LINK_PATTERN =
  /([\w.+-]+@[\w-]+(?:\.[\w-]+)+|(?:https?:\/\/)?(?:www\.)?[\w-]+\.com\b(?:\/(?:[\w\-./?=&#%]*[\w\-/=&#%])?)?)/gi;

// Turns emails (mailto:) and .com domains (https://) in plain text into links
export function linkify(text: string): React.ReactNode[] {
  return text.split(LINK_PATTERN).map((part, index) => {
    if (index % 2 === 0) return part;
    const isEmail = part.includes("@");
    const href = isEmail
      ? `mailto:${part}`
      : part.startsWith("http")
        ? part
        : `https://${part.toLowerCase()}`;
    return (
      <a
        key={index}
        href={href}
        className="text-primary hover:underline hover:underline-offset-4 dark:font-semibold dark:text-primary-accent dark:opacity-100"
      >
        {part}
      </a>
    );
  });
}

// Applies linkify to the plain strings of rich-text output (e.g. t.rich), leaving elements untouched
export function linkifyNode(node: React.ReactNode): React.ReactNode {
  if (typeof node === "string") return linkify(node);
  if (Array.isArray(node)) {
    return node.map((child, index) => (
      <React.Fragment key={index}>{linkifyNode(child)}</React.Fragment>
    ));
  }
  return node;
}
